import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Form, Input, InputNumber, message, Modal, Spin } from 'antd';
import PropTypes from 'prop-types';
import {
	getactionMessages,
	getCommissionMessages,
	getModalMessages,
	getPayrollMessages,
} from '../../constants/messages';
import { BeforeEditCommissionBrackets, LoadCommissionBrackets } from './actions';

let commissionMessages = getCommissionMessages(),
	actionMessages = getactionMessages(),
	modalMessages = getModalMessages(),
	payrollsMessages = getPayrollMessages();

const messages = {
	...commissionMessages,
	...actionMessages,
	...modalMessages,
	...payrollsMessages,
};

const EditCommissionBracketForm = ({
	bracket,
	handleCancel,
	showModal,
	setCommissionBrackets,
	commissionBrackets,
	bracketType,
}) => {
	const intl = useIntl();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const onEdit = async () => {
		try {
			setLoading(true);
			const values = await form.validateFields();
			await BeforeEditCommissionBrackets(commissionBrackets, bracket.index, values);
			const brackets = await LoadCommissionBrackets(bracketType);
			setCommissionBrackets(brackets);
			message.success(intl.formatMessage({ ...messages.saveConfigurationsSuccess }));
			handleCancel();
		} catch (error) {
			message.error(intl.formatMessage({ ...messages.saveConfigurationsError }));
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			title={intl.formatMessage({ ...messages.commissionRangeService })}
			open={showModal}
			onOk={onEdit}
			okText={intl.formatMessage({ ...messages.save })}
			cancelText={intl.formatMessage({ ...messages.cancel })}
			onCancel={handleCancel}
			destroyOnClose={true}
		>
			<Spin spinning={loading}>
				<Form form={form} layout="vertical" preserve={false}>
					<Form.Item name="id" hidden={true} initialValue={bracket.id}>
						<Input hidden={true} />
					</Form.Item>
					<Form.Item
						name="min"
						label={intl.formatMessage({ ...messages.minAmount })}
						initialValue={bracket.min}
					>
						<InputNumber
							className="full-component"
							min={0}
							formatter={(value) => `${value}$`}
							parser={(value) => value.replace('$', '')}
						/>
					</Form.Item>
					<Form.Item
						name="max"
						label={intl.formatMessage({ ...messages.maxAmount })}
						initialValue={bracket.max}
					>
						<InputNumber
							className="full-component"
							min={0}
							formatter={(value) => `${value}$`}
							parser={(value) => value.replace('$', '')}
						/>
					</Form.Item>
					<Form.Item
						name="multiplier"
						label={intl.formatMessage({ ...messages.multiplier })}
						initialValue={bracket.multiplier}
					>
						<InputNumber className="full-component" min={0} step={0.25} />
					</Form.Item>
				</Form>
			</Spin>
		</Modal>
	);
};

EditCommissionBracketForm.propTypes = {
	bracket: PropTypes.object.isRequired,
	handleCancel: PropTypes.func.isRequired,
	showModal: PropTypes.bool.isRequired,
	setCommissionBrackets: PropTypes.func.isRequired,
	commissionBrackets: PropTypes.array.isRequired,
	bracketType: PropTypes.number.isRequired,
};

export default EditCommissionBracketForm;
